export default __webpack_public_path__ + "static/media/Info.40032bf0.jpeg";